import { useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'
import { Button, Checkbox, Text } from '@mantine/core'
import { Typography } from '../common/typography'
import DOMPurify from 'dompurify'
import dayjs from 'dayjs'
import { useCourseDetails, useStartAttempt } from './api'
import classes from './Course.module.css'
import { IconChevronLeft } from '@tabler/icons-react'
import Header from '../common/components/header/Header'
import Meta from '../common/Meta'
import { useMediaQuery } from '@mantine/hooks'
import clsx from 'clsx'

export default function QuizConsent() {
  const navigate = useNavigate()
  const location = useLocation()
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const { courseId } = useParams<{ courseId: string }>()
  const { data: courseDetails } = useCourseDetails({
    course_id: Number(courseId),
  })
  const startAttemptMutation = useStartAttempt()
  const [consentGiven, setConsentGiven] = useState(false)

  const handleNext = async () => {
    try {
      const attempt = await startAttemptMutation.mutateAsync(Number(courseId))
      const firstGroupId = courseDetails.question_groups[0].question_group_id

      navigate(
        `/learning/course/${courseId}/quiz/${attempt.attempt_id}/question-group/${firstGroupId}`
      )
    } catch (error) {
      console.error('Failed to start quiz:', error)
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.consentContainer}>
        <div className={classes.headerContainer}>
          {isDesktop && (
            <IconChevronLeft
              onClick={() =>
                navigate(location.state?.from?.pathname || '/learning')
              }
              className={classes.backIcon}
            />
          )}
          <Header
            title="Learning XP"
            back={location.state?.from?.pathname || '/learning'}
          />
        </div>
        <Meta title="Learning XP" />
        <div
          className={clsx(
            classes.courseDescriptionContainer,
            classes.consentWrapper
          )}
        >
          <div className={classes.courseDescriptionHeader}>
            <Typography fs="xxl" fw={700} level={2} lh="100">
              {courseDetails.title}
            </Typography>
            <Typography
              fs="xs"
              fc={{ light: 'gray-5', dark: 'gray-5' }}
              lh="130"
            >
              {dayjs(courseDetails.created_at).format('DD/MM/YYYY, HH:mm')}
            </Typography>
          </div>

          <Text
            component="p"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(courseDetails.description),
            }}
          />

          <div className={classes.consentRow}>
            <Checkbox
              label="I agree to the privacy policy"
              checked={consentGiven}
              onChange={(event) => setConsentGiven(event.currentTarget.checked)}
              classNames={{
                root: classes.checkboxRoot,
                label: classes.checkboxLabel,
                body: classes.checkboxBody,
                input: classes.checkboxInput,
              }}
            />

            <Button
              className={classes.button}
              onClick={handleNext}
              disabled={!consentGiven}
              loading={startAttemptMutation.isPending}
            >
              <Typography
                fc={{ light: 'white', dark: 'white' }}
                lh="150"
                tt="uppercase"
              >
                Next
              </Typography>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
